import { debounce  } from 'lodash';
export default function stickyObserver(stickyItem, observerElement) {

    if (stickyItem && observerElement) {

        const handleStickyClass = debounce((isSticky: boolean) => {
            if (isSticky) {
                stickyItem.classList.add('is-sticky');
            } else {
                stickyItem.classList.remove('is-sticky');
            }
        }, 50);


        const observer = new IntersectionObserver(
            ([entry]) => {

                handleStickyClass(!entry.isIntersecting);
            },
            {
                threshold: 0,
                rootMargin: '-1px 0px 0px 0px'
            }
        );

        observer.observe(observerElement);

    }
}